module.exports = __webpack_public_path__ + "static/media/40d36b4a-60c6-460a-bf43-4c948c23563e.5816586f.woff2";